// extracted by mini-css-extract-plugin
export default {"banner-img":"Banner_banner-img__DsEEe","banner-text":"Banner_banner-text__0PP83","collection-text":"Banner_collection-text__pgxBj"};